import React, {Suspense, memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type StaticHeaderBannerContentWrapperProps = {
    quickLinkCount: number
    enableContentBanner: boolean
    showCountrySelector: boolean
    xxlBreakpointEnabled: boolean
    children: React.ReactNode
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

const StaticHeaderBannerContentWrapper = memo((props: StaticHeaderBannerContentWrapperProps) => {
    const {templating} = props
    const TemplatedWrapper = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <TemplatedWrapper {...props} />
        </Suspense>
    )
})

StaticHeaderBannerContentWrapper.displayName = "StaticHeaderBannerContentWrapper"

export default connect(StaticHeaderBannerContentWrapper)
